import {ACTION_CODE} from './_actionCode';
import {AttachmentTypeDao} from '../../dao';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_ATTACHMENT';

export async function createAttachmentType(userData: Record<string, any>, payload: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createAttachmentType - Start');

        const createAttachmentTypeResult = await AttachmentTypeDao.createAttachmentType(userData.userToken, payload);

        LoggerService.logInfo('Action - createAttachmentType - End - Success');

        return ResultModel.newSuccessResult(createAttachmentTypeResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createAttachmentType - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
